import { createSelector } from 'reselect'
import getIsLoyaltyEsimEnabled from './getIsLoyaltyEsimEnabled'

function getCanShowLoyaltyEsimBenefitSelector(
  getIsInternationalTrip: (state: App.State) => boolean,
) {
  return createSelector(
    (state: App.State) => getIsLoyaltyEsimEnabled(state),
    (state: App.State) => getIsInternationalTrip(state),
    (state: App.State) => state.loyalty.account.data?.benefits,
    (isEsimEnabled, isInternationalTrip, benefits): boolean => {
      if (!isEsimEnabled || !isInternationalTrip) return false
      return !!benefits?.some(b => b.code === 'esim_package')
    },
  )
}

export default getCanShowLoyaltyEsimBenefitSelector
